export default __webpack_public_path__ + "static/media/ClickUp.eaf8379a.svg";